export const limit = 60;

export const radioStreams = [
  { id: 120105651, url: 'https://stream.vilniusfm.lt/hls/hls/program.m3u8' },
  { id: 120105666, url: 'https://stream1.rc.lt/rc128.mp3' },
  { id: 120105665, url: 'https://stream1.rc.lt/relaxfm128.mp3' },
  { id: 120105605, url: 'https://stream1.rc.lt/zipfm128.mp3' },
  { id: 120105668, url: 'https://stream1.rc.lt/rrb128.mp3' },
  { id: 120105664, url: 'https://stream1.rc.lt/crf128.mp3' },
  { id: 120105669, url: 'https://stream3.rc.lt/fiesta.mp3' },
];
